import React from 'react';
import { SvgIcon } from '@mui/material';

function MessagesIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 90 90">
      <path
        d="M82.4699 89.3901H45.0099C20.5299 89.3901 0.609863 69.4801 0.609863 45.0001C0.609863 20.5201 20.5199 0.610107 45.0099 0.610107C69.4999 0.610107 89.3799 20.5201 89.3799 45.0001V82.4701C89.3799 86.2801 86.2799 89.3801 82.4599 89.3801L82.4699 89.3901ZM45.0099 7.30011C24.2199 7.30011 7.29987 24.2101 7.29987 45.0001C7.29987 65.7901 24.2199 82.7001 45.0099 82.7001H82.4699L82.6999 45.0001C82.6999 24.2101 65.7899 7.30011 45.0099 7.30011Z"
        fill="currentColor"
      />
      <path
        d="M67.4901 50.2901H24.6701C22.8201 50.2901 21.3301 48.7901 21.3301 46.9501C21.3301 45.1101 22.8301 43.6101 24.6701 43.6101H67.4901C69.3401 43.6101 70.8301 45.1101 70.8301 46.9501C70.8301 48.7901 69.3301 50.2901 67.4901 50.2901Z"
        fill="currentColor"
      />
      <path
        d="M67.4899 66.18H42.1999C40.3499 66.18 38.8599 64.68 38.8599 62.84C38.8599 61 40.3599 59.5 42.1999 59.5H67.4899C69.3399 59.5 70.8299 61 70.8299 62.84C70.8299 64.68 69.3299 66.18 67.4899 66.18Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default MessagesIcon;
